<template>
  <div
    class="fts-test-badge">
    {{getBadgeLabel}}
  </div>
</template>

<script>

export default {
  props: {
    stage: String,
  },
  computed: {
    getBadgeLabel() {
        if (this.stage == "test")
          return 'test'
        else if(this.stage == 'dev')
          return "dev";
        else if(this.stage == 'internal')
          return "internal";
    },
  }
}
</script>

<style lang="scss">
.fts-test-badge {
  height: 0.875rem;
  display: inline-flex;
  padding: 0 0.25rem;
  border-radius: 0.125rem;
  background-color: var(--fts-light);
  color: var(--fts-primary);
  text-transform: uppercase;
  font-weight: 400;
  font-style: normal;
  font-size: 0.625rem;
  line-height: 0.875rem;
  white-space: normal;
}
</style>